const socketio = {
	state: {

	},
	mutations: {
		SOCKET_NOTIFY_CONNECT_USER_ (state, data) {
			let date = new Date()
			console.log('Un usuario a entrado ' + date)
			console.log(data)
		},
		SOCKET_NOTIFY_DISCONNECT_USER (state, data) {
			console.log('Usuario descoenctado')
			console.log(data)
		},

	},
	actions: {
	},
}

export default socketio